<template>
  <div>
    <div class="max-w-xl">
      <FormulateForm
        v-model="formValues"
        class="form-wrapper"
        @submit="onSubmit"
        #default="{ isLoading }"
        name="requestForm">
        <div class="flex flex-col pt-2 px-4">
          <div class="flex flex-row gap-3">
            <div class="mt-4 w-1/3">
              <FormulateInput
                type="select"
                name="as_role"
                label="Select a Role"
                @input="onSelectRole()"
                :value="roleInfo.as_role"
                :options="roles"
              />
            </div>
            <div class="mt-4 w-2/3" v-if="formValues.as_role === 'vendor'">
              <FormulateInput
                type="vue-select"
                name="code"
                :value="roleInfo.code"
                label="Select a Vendor Abbreviation"
                :options="RouteList"
                validation="required"
              />
            </div>
            <div class="mt-4 w-2/3" v-if="formValues.as_role === 'district'">
              <FormulateInput
                type="vue-select"
                name="code"
                :value="roleInfo.code"
                label="Select a District Code"
                :options="districtList"
                validation="required"
              />
            </div>
          </div>
          <div class="mt-4">
            <FormulateInput
              type="checkbox"
              name="filter_students"
              label="Filter Students"
              help="(Unselect this option to see all students)"
            />
          </div>
          <div class="mt-4">
            <FormulateInput
              type="checkbox"
              name="search_partitions"
              label="Search Across All Partitions"
              help="(Select this option to search every student across all states/partitions)"
            />
          </div>
          <div class="text-center mt-3 mb-3">
            <FormulateErrors />
            <FormulateInput
              class="hidden"
              type="submit"
              :disabled="isLoading"
              :label="isLoading ? 'Loading...' : 'Save'"
              validation-behavior="live"
            />
          </div>
        </div>
      </FormulateForm>
      <!-- Endpoint Data: {{ formValues }} <p></p> -->
    </div>
  </div>
</template>

<script>
import { getVendor, getDistrict } from '../services/api.js'
import settings from '../services/settings.js'
import events from '../services/events.js'

export default {
  props: {
    roleInfo: {}
  },
  data() {
    return {
      formValues: {
        filter_students: false,
        search_partitions: false,
      },
      roles: {
        district: 'District',
        vendor: 'Vendor'
      },
      RouteList: [],
      districtList: []
    }
  },
  methods: {
    async onSubmit() {
      let response = await settings.changeRole(this.formValues)
      let output = true
      if (response.status !== 200) {
        output = false
        if (response.status === 409) {
          alert(
            `"Filter Students" option enabled for student outside of currently selected district. Either disable it or change to match students' district.`
          )
        }
        console.log(response.statusText)
      }
      events.trigger('operationsSettingsFormUpdate', this.formValues)
      this.formValues = {}
      return output
    },
    onSelectRole() {
      this.formValues.code = undefined
    }
  },
  created() {
    settings.user().then(user => {
      this.formValues.filter_students = user.getMeta('filter_students')
      this.formValues.search_partitions = user.getMeta('search_partitions')
    })
    getVendor()
      .then(result => result.data)
      .then(
        result => {
          for (const vendor of result) {
            this.RouteList.push({
              value: vendor.id,
              label: vendor.abbreviation
            })
          }
        },
        error => {
          console.error(error)
        }
      )
    getDistrict()
      .then(result => result.data)
      .then(
        result => {
          for (const district of result) {
            this.districtList.push({
              value: district.code,
              label: `${district.code}: ${district.name}`
            })
          }
          // this.districtList.sort((a, b) => a.value.localeCompare(b.value))
          // console.log(this.districtList)
        },
        error => {
          console.error(error)
        }
      )
  }
}
</script>
